// @flow
import type {
	TRootStore,
} from "../../types";

export const isMenuOpen = (state: TRootStore) => state.uiMenu.open;
export * from "./rightMenu";
export * from "./leftMenu";